<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h2"><i class="fa-solid fa-user-tie me-2"></i>Kunden ({{totalEntries}})</h1>
</div>

<button type="button" class="btn btn-primary mb-3 me-2" [routerLink]="['/customer', 0]">Kunde anlegen</button>

<!--<button type="button" class="btn btn-primary mb-3" [disabled]="importing" (click)="triggerFileInput()" *ngIf="accessService.hasRight('ADMIN')">
    <i class="fa-solid fa-file-csv me-2"></i>Kundendaten importieren
</button>
<input type="file" #inputFile class="d-none" (change)="handleInputChange($event)">-->

<div class="text-bg-warning p-3 mb-3" *ngIf="importing">
    <i class="fa-solid fa-circle-notch fa-spin me-2"></i>Import wird durchgeführt, bitte warten..
</div>

<pagination
        [hidden]="entries?.length == 0"
        [totalItems]="totalEntries"
        [itemsPerPage]="paginConfig.itemsPerPage"
        [(ngModel)]="paginConfig.page"
        (pageChanged)="listEntries($event)"
        [maxSize]="20"
        previousText="Letzte"
        nextText="Nächste">
</pagination>

<div class="table-responsive">

    <div [class.fw-bold]="search.lastname != ''"><small>Das Suchfeld für Name durchsucht Vorname, Nachname, Nachname 2 und Nachname 3, angezeigt wird Nachname</small></div>
    <div [class.fw-bold]="search.phone != ''" class="mb-1"><small>Das Suchfeld für Telefon durchsucht Telefon, Mobil-Nummer und Privat-Nummer, angezeigt wird Telefon</small></div>

    <table class="table table-sm table-striped table-hover bg-white pointer">
        <thead>
        <tr>
            <th>
                <input type="text" class="form-control" [(ngModel)]="search.number" [class.search-active]="search.number != ''" appDebounceKeyup (debounceKeyup)="checkFilterAndList()">
            </th>
            <th>
                <input type="text" class="form-control" [(ngModel)]="search.lastname" [class.search-active]="search.lastname != ''" appDebounceKeyup (debounceKeyup)="checkFilterAndList()">
            </th>
            <th>
                <input type="text" class="form-control" [(ngModel)]="search.zip" [class.search-active]="search.zip != ''" appDebounceKeyup (debounceKeyup)="checkFilterAndList()">
            </th>
            <th>
                <input type="text" class="form-control" [(ngModel)]="search.city" [class.search-active]="search.city != ''" appDebounceKeyup (debounceKeyup)="checkFilterAndList()">
            </th>
            <th>
                <input type="text" class="form-control" [(ngModel)]="search.street" [class.search-active]="search.street != ''" appDebounceKeyup (debounceKeyup)="checkFilterAndList()">
            </th>
            <th>
                <input type="text" class="form-control" [(ngModel)]="search.phone" [class.search-active]="search.phone != ''" appDebounceKeyup (debounceKeyup)="checkFilterAndList()">
            </th>
        </tr>
        <tr>
            <th (click)="setOrder('number')">
                Nummer <i class="fas" *ngIf="predicate == 'number'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('lastname')">
                Name <i class="fas" *ngIf="predicate == 'lastname'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('zip')">
                PLZ <i class="fas" *ngIf="predicate == 'zip'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('city')">
                Ort <i class="fas" *ngIf="predicate == 'city'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('street')">
                Straße <i class="fas" *ngIf="predicate == 'street'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('phone')">
                Telefon <i class="fas" *ngIf="predicate == 'phone'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <!--<th (click)="setOrder('tasks')">
                # Aufgaben <i class="fas" *ngIf="predicate == 'tasks'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>-->
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let entry of entries" [routerLink]="['/customer', entry.id]">
            <td>{{ entry.number }}</td>
            <td>{{ entry.lastname }}</td>
            <td>{{ entry.zip }}</td>
            <td>{{ entry.city }}</td>
            <td>{{ entry.street }}</td>
            <td>{{ entry.phone }}</td>
            <!--<td>{{ entry.tasks }}</td>-->
        </tr>
        </tbody>
    </table>
</div>
